export default "__VITE_ASSET__DIC5RvGy__"